/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountScimSettings {
    getFixupPrototypeFunction() { return MasterAccountScimSettings.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountScimSettings>): MasterAccountScimSettings {
        let obj = Object.assign(new MasterAccountScimSettings(), model);
        MasterAccountScimSettings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountScimSettings>): MasterAccountScimSettings {
        if (!model) return null;
        return MasterAccountScimSettings.newInstance(<MasterAccountScimSettings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountScimSettings) {
        if (!obj) return;

        models.MasterAccountScimSettings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountScimSettings): boolean {
        Object.setPrototypeOf(obj, MasterAccountScimSettings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.enabled_at === "string") {
            this.enabled_at = new Date(<string><any>this.enabled_at);
        }
        if (typeof this.last_used_at === "string") {
            this.last_used_at = new Date(<string><any>this.last_used_at);
        }
    }

    /**
     * Whether SCIM 2.0 provisioning is enabled for this master account
     */
    enabled: boolean;

    /**
     * Bearer token the SCIM provisioner must present. Only populated while SCIM is enabled
     */
    bearer_token: string;

    /**
     * DateTime in UTC when SCIM provisioning was enabled
     */
    enabled_at: Date;

    /**
     * Name of the user who enabled SCIM provisioning
     */
    enabled_by: string;

    /**
     * DateTime in UTC when the SCIM bearer token was last used
     */
    last_used_at: Date;

}
